// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"loading_ldsEllipsis__PcWWi","ldsEllipsis1":"loading_ldsEllipsis1__0mFDT","ldsEllipsis2":"loading_ldsEllipsis2__TFnso","ldsEllipsis3":"loading_ldsEllipsis3__hUaJ4"};